import { render, staticRenderFns } from "./importPreview.vue?vue&type=template&id=0c3ff8ae&scoped=true&"
import script from "./importPreview.vue?vue&type=script&lang=js&"
export * from "./importPreview.vue?vue&type=script&lang=js&"
import style0 from "./importPreview.vue?vue&type=style&index=0&id=0c3ff8ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3ff8ae",
  null
  
)

export default component.exports